import { Formio, Components } from 'formiojs';

import DataTileCore from "./dataTileCore";
import "./style.css";

const Field = Components.components.field;

export default class DataTile extends Field {

    constructor(component, options, data) {
        super(component, options, data);
        this.component = component;
        this.dataTileCore = new DataTileCore(component);
    }

    static editForm = Components.components.radio.editForm;

    /**
     * This is the default schema of your custom component. It will "derive"
     * from the base class "schema" and extend it with its default JSON schema
     * properties. The most important are "type" which will be your component
     * type when defining new components.
     *
     * @param extend - This allows classes deriving from this component to 
     *                 override the schema of the overridden class.
     */
    static schema(...extend) {
        return Field.schema({
            type: 'dataTileComp',
            label: 'Data Tile',
            key: 'dataTile',
        });
    }

    /**
     * This is the Form Builder information on how this component should show
     * up within the form builder. The "title" is the label that will be given
     * to the button to drag-and-drop on the buidler. The "icon" is the font awesome
     * icon that will show next to it, the "group" is the component group where
     * this component will show up, and the weight is the position within that
     * group where it will be shown. The "schema" field is used as the default
     * JSON schema of the component when it is dragged onto the form.
     */
    static builderInfo = {
        title: "Data Tile",
        icon: "th",
        group: "VSee Clinic",
        documentation: "",
        weight: -10,
        schema: DataTile.schema()
    };

    /**
     * Called immediately after the component has been instantiated to initialize
     * the component.
     */
    init () {
        super.init();
        if (this.dataTileCore) {
            this.dataTileCore.loadData().then(() => {
                this.redraw();
            });
        }
    }

    /**
     * After the html string has been mounted into the dom, the dom element is returned here. Use refs to find specific
     * elements to attach functionality to.
     *
     * @param element
     * @returns {Promise}
     */
    attach(element) {
        const refs = {};
        // Iterate through all cells and add refs.
        var datas = this.dataTileCore.getData();
        for (let i in datas) {
            refs[this.dataTileCore.getRef(datas[i])] = 'single';
        }

        // Load the references.
        this.loadRefs(element, refs);

        for (let i in datas) {
            this.addEventListener(this.refs[this.dataTileCore.getRef(datas[i])], 'click',
                () => {
                    this.dataTileCore.setSelected(datas[i]);
                    this.setValue(datas[i]);
                });
        }

        return super.attach(element);
    }

    detach() {
        return super.detach();
    }

    destroy() {
        return super.destroy();
    }

    getValue() {
        return super.getValue();
    }

    /**
     * Sets the value of both the data and view of the component (such as setting the
     * <input> value to the correct value of the data. This is most commonly used
     * externally to set the value and also see that value show up in the view of the
     * component. If you wish to only set the data of the component, like when you are
     * responding to an HMTL input event, then updateValue should be used instead since
     * it only sets the data value of the component and not the view. 
     *
     * @param value - The value that is being set for this component's data and view.
     * @param flags - Change propogation flags that are being used to control behavior of the
     *                change proogation logic.
     *
     * @return - Boolean indicating if the setValue changed the value or not.
     */
    setValue(value, flags = {}) {
        return super.setValue(value, flags);
    }

    render(content) {
        return super.render(this.dataTileCore.render());
    }
}

Formio.use({
    components: {
        dataTileComp: DataTile
    }
});
